import { House, MapPin, Ruler } from "lucide-react"

interface HousingFactsProps {
  floorAreaM2?: number
  houseType?: string
  location?: string
  statusLabel?: string
}

export function HousingFacts({
  floorAreaM2,
  houseType,
  location,
  statusLabel,
}: HousingFactsProps) {
  if (!floorAreaM2 || !houseType) return null

  const formattedMetricArea = new Intl.NumberFormat("en", {
    maximumFractionDigits: 1,
  }).format(floorAreaM2)
  const formattedImperialArea = new Intl.NumberFormat("en", {
    maximumFractionDigits: 0,
  }).format(floorAreaM2 * 10.7639)

  return (
    <div className="mx-auto mb-4 w-full max-w-xl">
      {statusLabel && (
        <p className="mx-auto mb-2 w-fit rounded-full border border-white/25 bg-black/60 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white/80 shadow-[0_8px_24px_rgba(0,0,0,0.2)] backdrop-blur-md">
          {statusLabel}
        </p>
      )}
      <dl
        className={`grid overflow-hidden rounded-xl border border-white/30 bg-black/65 text-left shadow-[0_12px_32px_rgba(0,0,0,0.3)] backdrop-blur-md ${
          location ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-2"
        }`}
      >
        {location && (
          <div className="col-span-2 flex min-w-0 items-center gap-2.5 border-b border-white/15 px-3 py-2.5 sm:col-span-1 sm:border-b-0 sm:px-4">
            <MapPin className="size-4 shrink-0 text-[#ff8b7f]" aria-hidden="true" />
            <div className="min-w-0">
              <dt className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/55 sm:text-[10px]">
                Location
              </dt>
              <dd className="text-sm font-bold leading-tight text-white md:text-base">
                {location}
              </dd>
            </div>
          </div>
        )}
        <div
          className={`flex min-w-0 items-center gap-2.5 px-3 py-2.5 sm:px-4 ${
            location ? "sm:border-l sm:border-white/15" : ""
          }`}
        >
          <Ruler className="size-4 shrink-0 text-[#ff8b7f]" aria-hidden="true" />
          <div className="min-w-0">
            <dt className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/55 sm:text-[10px]">
              Total area
            </dt>
            <dd className="text-sm font-bold leading-tight text-white md:text-base">
              {formattedMetricArea} m²
            </dd>
            <dd className="mt-0.5 text-[11px] font-semibold text-white/65 md:text-xs">
              {formattedImperialArea} ft²
            </dd>
          </div>
        </div>
        <div className="flex min-w-0 items-center gap-2.5 border-l border-white/15 px-3 py-2.5 sm:px-4">
          <House className="size-4 shrink-0 text-[#ff8b7f]" aria-hidden="true" />
          <div className="min-w-0">
            <dt className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/55 sm:text-[10px]">
              House type
            </dt>
            <dd className="whitespace-normal text-sm font-bold leading-tight text-white md:text-base">
              {houseType}
            </dd>
          </div>
        </div>
      </dl>
    </div>
  )
}
